import { Component, OnInit, Inject } from "@angular/core";
import { UserVerificationService } from "../../../shared/services/user-verification.service";
import { ActivatedRoute, Router, Params } from "@angular/router";
import swal from "sweetalert2";
import { DOCUMENT } from "@angular/common";
import { RolesSharedService } from "@app/feature/main/roles-shared/services/roles-shared.service";
import { environment } from "@env/environment";
import { Newsletter } from "@app/feature/external/newsletter";
import { BreadcrumService } from "@app/shared/services/breadcrum.service";
import { DomSanitizer, Meta, Title } from "@angular/platform-browser";
import { LoaderService } from "@app/shared/services/loader.service";
import * as _ from "lodash";
declare var window: any;

declare var $: any;
@Component({
  selector: "app-public-page",
  templateUrl: "./public-page.component.html",
  styleUrls: ["./public-page.component.css"],
})
export class PublicPageComponent implements OnInit {
  ecosystmTvUrl: string;
  noDataCheck: boolean = false;
  newsletter = new Newsletter();
  userAccessToken = "";
  currentTabStatus: string = "";
  userId = "";
  viewTopArrow = false;
  trendingResearchObj = [];
  reportsData: any;
  analystData: any;
  blogsList: any;
  blogURL: any;
  socialFeedsObject: any;
  techDomainListselected: string;
  getSocialFeedsCall = false;
  wpAutoLoginUrl: string = "";
  showNewsletterSuccessMsg: boolean = false;
  showNewsletterErrMsg: boolean = false;
  customerList = [];
  searchKeyword = "";
  searchString = "";
  filterKeyId: string;
  noResearchData: boolean;
  user_info: any;
  parsedData: any;
  org_id: any;
  role_name: any;
  totalRecords = 0;
  dataLimit = 10;
  skipValue = 0;
  sortSelectedindex = null;
  allResearchData = [];
  ecosystmTvList;
  titles: any;
  constructor(
    private userVerificationService: UserVerificationService,
    private route: ActivatedRoute,
    private router: Router,
    private rolesSharedService: RolesSharedService,
    private breadcrumService: BreadcrumService,
    private titleService: Title,
    private loaderService: LoaderService,
    public domSanitizer: DomSanitizer,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.wpAutoLoginUrl = environment.WP_AUTO_LOGIN_URL;
    this.document.body.classList.remove("inner-page");
    this.document.body.classList.add("outer-page");
  }

  ngOnInit() {
    const tempSession = sessionStorage.getItem("userDetails");
    localStorage.setItem("tempSession", tempSession);

    this.blogURL = environment.BLOG_URL;
    this.ecosystmTvUrl = environment.ECOSYSTM_TV_URL;
    this.route.queryParams.subscribe((params: Params) => {
      if (params["userAccessToken"] && params["userId"]) {
        this.userAccessToken = params["userAccessToken"];
        this.userId = params["userId"];
        this.verifyUser();
      }
    });
    $("window").on("touchmove", (event) => {
      this.myFunction();
    });
    window.onscroll = () => {
      this.myFunction();
    };
    this.techDomainListselected = window.localStorage.getItem(
      "selectedTechDomainId"
    )
      ? window.localStorage.getItem("selectedTechDomainId")
      : null;
    this.scrollTopArrowStatus();
    // this.trendingResearchDataObject();
    this.getAllResearchData();
    this.reportsListDataObject();
    this.getAnalystList();
    this.getBlogsList();
    this.getEcosystmTVList();
    this.getSocialFeeds();
    this.getOurCustomerDetails();
    window.location.href = "https://www.ecosystm.io";
  }

  verifyUser() {
    this.userVerificationService
      .verifyUser(this.userId, this.userAccessToken)
      .subscribe(
        (response) => {
          swal("Great", "You are good to login", "success");
          this.router.navigate(["/signin"]);
        },
        (error) => {
          if (error.error.error.statusCode === 422) {
            swal("Info", error.error.error.message, "info");
            this.router.navigate(["/signin"]);
          } else {
            swal("Info", error.error.error.message, "info");
          }
        }
      );
  }

  getTrendingDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        {
          research: [
            {
              survey: {
                responses: "users",
              },
            },
            "domain",
          ],
        },
        {
          likes: "user",
        },
        {
          comments: "user",
        },
        "ratings",
      ],
    });
    filter.limit = 3;
    filter.skip = 0;
    filter.sort = JSON.stringify({ postedDate: "DESC" });

    console.log("filter.sort:", JSON.stringify({ postedDate: "DESC" }));
    console.log("filter:", filter);
    return filter;
  }

  trendingResearchDataObject() {
    this.rolesSharedService
      .getTrendingResearches(this.getTrendingDataFilter())
      .subscribe(
        (response: any) => {
          window.scroll(0, 0);

          this.trendingResearchObj = response.data;
          // this.trendingResearchObj = this.trendingResearchObj.sort((a,b)=> b.research.postedDate - a.research.postedDate);
        },
        (error) => {}
      );
  }

  getAllResearchData() {
    this.noDataCheck = false;
    let searchKey = this.searchString;
    let filterKey = this.filterKeyId;
    this.rolesSharedService
      .getAllResearches(this.allResearchDataFilter())
      .subscribe(
        (response: any) => {
          this.allResearchData = response.data;
          this.allResearchData = this.allResearchData.sort(
            (a, b) =>
              new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        },
        (error) => {}
      );
    // return this.searchKeyword;
  }
  allResearchDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        { survey: { responses: "users" } },
        "domain",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" },
        { bookmark: "user" },
      ],
    });
    filter.limit = this.dataLimit;
    filter.skip = this.skipValue;
    filter.search = this.searchString;
    filter.sort = this.sortSelectedindex
      ? JSON.stringify(this.sortSelectedindex)
      : JSON.stringify({ postedDate: "DESC" });
    if (this.techDomainListselected) {
      filter.where = JSON.stringify({
        techDomainId: this.techDomainListselected,
      });
    }

    return filter;
  }

  reportsDataFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      include: [
        "users",
        "domains",
        { likes: "user" },
        { comments: "user" },
        { ratings: "user" },
      ],
    });
    filter.where = JSON.stringify({
      status: "published",
    });
    filter.limit = 10;
    filter.skip = 2;
    filter.sort = JSON.stringify({ postedDate: "DESC" });
    return filter;
  }

  reportsListDataObject() {
    this.rolesSharedService.getReports(this.reportsDataFilter()).subscribe(
      (response: any) => {
        window.scroll(0, 0);
        this.reportsData = response.data;
        // this.totalRecords = response.totalCount;
      },
      (error) => {}
    );
  }

  getAnalystListFilter() {
    const filter: any = {};
    filter.filter = JSON.stringify({
      where: {
        and: [
          {
            code: "tech_analyst",
          },
        ],
      },
      include: [
        {
          relation: "followers",
        },
        "ratings",
      ],
      limit: 5,
    });
    return filter;
  }

  getAnalystList() {
    this.rolesSharedService
      .getAnalystListDetails(this.getAnalystListFilter())
      .subscribe((data: any) => {
        this.analystData = data;
      });
  }

  blogsFilter() {
    let filter: any = {};
    filter.limit = 10;
    filter.skip = 2;
    return filter;
  }
  getBlogsList() {
    this.rolesSharedService.getBlogs(this.blogsFilter()).subscribe(
      (response: any) => {
        window.scroll(0, 0);
        this.blogsList = response;
      },
      (error) => {}
    );
  }

  blogItemClick(blogData: any) {
    let token = this.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&id=${blogData.ID}`;
      window.open(blogUrl, "_self");
    } else {
      window.open(blogData.guid, "_self");
    }
  }
  ecosystmTvClick(tvData: any) {
    let token = this.getToken();
    if (token) {
      const blogUrl = `${this.wpAutoLoginUrl}?accesstoken=${token}&id=${tvData.id}`;
      window.open(blogUrl, "_self");
    } else {
      window.open(tvData.link, "_self");
    }
  }

  viewAllBlog() {
    window.open(this.blogURL, "_self");
  }

  loginAlert(reportID) {
    // fix reditect login
    window.localStorage.setItem("isFromHome", "true");
    localStorage.removeItem("REDIRECT_URL");
    localStorage.setItem("REPORT_URL", `/report-details/${reportID}`);
    this.router.navigate(["/signin"]);
  }

  loginAlertForResearch(researchID) {
    // fix reditect login
    window.localStorage.setItem("isFromHome", "true");
    localStorage.removeItem("RESEARCH_URL");
    localStorage.removeItem("RESEARCH_BUYER_URL");
    localStorage.removeItem("RESEARCH_ANALYST_URL");
    localStorage.removeItem("RESEARCH_STAFF_URL");

    localStorage.setItem("RESEARCH_URL", `/market-data/${researchID}`);
    localStorage.setItem("RESEARCH_BUYER_URL", `/${researchID}`);
    localStorage.setItem("RESEARCH_ANALYST_URL", `/${researchID}`);
    localStorage.setItem("RESEARCH_STAFF_URL", `/${researchID}`);

    this.router.navigate(["/signin"]);
  }
  socialFeedsFilter() {
    const filter: any = {};
    filter.limit = 3;
    if (this.techDomainListselected) {
      filter.techDomainId = this.techDomainListselected;
    }
    return filter;
  }
  getToken() {
    let token = null;
    let userData = null;
    userData = JSON.parse(window.localStorage.getItem("userDetails"));
    if (userData) {
      token = userData.accessToken;
    } else {
      userData = JSON.parse(window.sessionStorage.getItem("userDetails"));
      token = userData != null ? userData.accessToken : null;
    }
    return token;
  }

  getSocialFeeds() {
    this.rolesSharedService
      .getSocialFeedList(this.socialFeedsFilter())
      .subscribe(
        (response: any) => {
          this.socialFeedsObject = response.data;
        },
        (error) => {}
      );
  }

  scroll(el) {
    el.scrollIntoView(true);
    window.scrollBy(0, -70);
  }

  scrollTopArrowStatus() {
    $(document).scroll(() => {
      if ($(window).scrollTop() === 0) {
        this.viewTopArrow = false;
      } else {
        this.viewTopArrow = true;
      }
    });
  }

  routeSigninPage() {
    this.router.navigate(["signin"]);
  }

  routeTrendingResearch() {
    this.router.navigate(["all-research"]);
  }

  routeReports() {
    this.router.navigate(["account/reports"]);
  }

  routeAnalystList() {
    this.router.navigate(["analyst-list"]);
  }

  routeBlogs() {
    this.router.navigate(["blogs"]);
  }

  routeToLogin() {
    this.router.navigate(["signin"]);
  }

  viewTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  scrollHomeSection(tabStatus?: string) {
    if (tabStatus == "socialFeeds") {
      if (!this.getSocialFeedsCall) this.getSocialFeeds();
      this.getSocialFeedsCall = true;
    }

    const anchor = this.document.getElementById("anchor");
    anchor.scrollIntoView(true);
  }
  scrollSection(tabStatus?: string) {
    // normal href link doesn't work.
    const myElement = this.document.getElementById(tabStatus);
    // let topPosition = myElement.offsetTop + 5;
    let paddingCompensate = 130;
    let topPosition = myElement.offsetTop - paddingCompensate;
    // adding 5 pixel to nullify the issue in selected tab due to padding.
    // document.getElementById('scroll-div-section').scrollTop = topPosition;
    window.scrollTo(0, topPosition);
    //myElement.scrollIntoView();
  }

  saveNewslatter(newsletterForm, model: Newsletter, isValid: boolean) {
    this.showNewsletterSuccessMsg = false;
    this.showNewsletterErrMsg = false;
    if (isValid) {
      model["ipAddress"] = "127.0.0.1";
      model["message"] = "subscribe to news letter";

      this.rolesSharedService.contactUsData(model).subscribe(
        (response) => {
          this.showNewsletterSuccessMsg = true;
          newsletterForm.reset();

          this.titleService.setTitle(
            "Message: " + model["message"] || "Subscribe to news letter"
          );
          var _hsq = ($._hsq = $._hsq || []);
          _hsq.push([
            "trackEvent",
            {
              id: response,
              value: response,
            },
          ]);
          _hsq.push(["trackPageView"]);
          _hsq.push(["refreshPageHandlers"]);
        },
        (error) => {
          this.showNewsletterErrMsg = true;
        }
      );
    }
  }

  // FIX: Analyst Profile redirection
  routeTechAnalystProfilePage(analystId: string, firstName, secondName) {
    sessionStorage.removeItem("sheduleCallUrl");
    sessionStorage.removeItem("sheduleCallLabel");
    sessionStorage.setItem("analystName", firstName + " " + secondName);
    this.router.navigate(["analyst-profile"], {
      queryParams: { analystId: analystId },
    });
  }

  showUserDetails(data) {
    if (data && data.postType === "analyst") {
      const fullName = data.title;
      this.breadcrumService.setUrl("BC3Label", name);
      this.router.navigate(["analyst-profile"], {
        queryParams: { analystId: data.postId },
      });
    }
  }
  routeToServicePage() {
    this.router.navigate(["our-services"]);
  }
  getOurCustomerDetails() {
    let type = "our_customers";
    this.rolesSharedService.getCustomerDeatils(type).subscribe((response) => {
      this.customerList = response[0].cmsPost[0].cmsPostDetails;
      //  this.customerList = this.customerList.sort((a,b)=> b.createdAt - a.createdAt);
      this.customerList = this.customerList.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
    });
  }

  setFlagToViewAll() {
    window.localStorage.setItem("isFromHome", "true");
    console.log("From view all, from public page");
  }

  myfun(tabStatus?: string) {
    this.currentTabStatus = tabStatus;
  }

  myFunction() {
    let navbar = document.getElementById("landing-page-list-tab");
    if (navbar !== null) {
      let sticky = navbar.offsetTop;
      navbar.classList.add("sticky");
      let paddingCompensate = 160;
      let researchSectionTop =
        document.getElementById("research-landing-tab").offsetTop -
        paddingCompensate;
      let researchSection = document.getElementById("research-tab");

      let reportSectionTop =
        document.getElementById("report-landing-tab").offsetTop -
        paddingCompensate;
      let reportSection = document.getElementById("report-tab");

      let analystSectionTop =
        document.getElementById("analysts-landing-tab").offsetTop -
        paddingCompensate;
      let analystSection = document.getElementById("analyst-tab");

      let blogSectionTop =
        document.getElementById("blogs-landing-tab").offsetTop -
        paddingCompensate;
      let blogSection = document.getElementById("blog-tab");

      let socialFeedSectionTop =
        document.getElementById("ecosystmtv-landing-tab").offsetTop -
        paddingCompensate;
      let socialFeedSection = document.getElementById("ecosystmtv-tab");

      let topSectionLimit =
        document.getElementById("nav-sticky-section").offsetTop - 60;
      let bottomSectionLimit =
        document.getElementById("news-letter-div").offsetTop -
        paddingCompensate;

      researchSection.classList.remove("active");
      reportSection.classList.remove("active");
      analystSection.classList.remove("active");
      blogSection.classList.remove("active");
      socialFeedSection.classList.remove("active");

      if (this.currentTabStatus !== "") {
        let researchSection = document.getElementById("research-tab");
        let reportSection = document.getElementById("report-tab");
        let analystSection = document.getElementById("analyst-tab");
        let blogSection = document.getElementById("blog-tab");
        let socialFeedSection = document.getElementById("ecosystmtv-tab");

        if (
          window.pageYOffset > topSectionLimit &&
          window.pageYOffset < bottomSectionLimit
        ) {
          navbar.classList.add("sticky");
        }
      }
      if (
        window.pageYOffset > topSectionLimit &&
        window.pageYOffset < bottomSectionLimit
      ) {
        if (window.pageYOffset > researchSectionTop) {
          researchSection.classList.add("active");
        } else if (window.pageYOffset > analystSectionTop) {
          analystSection.classList.add("active");
        } else if (window.pageYOffset > reportSectionTop) {
          reportSection.classList.add("active");
        } else if (window.pageYOffset > socialFeedSectionTop) {
          socialFeedSection.classList.add("active");
        } else if (window.pageYOffset > blogSectionTop) {
          blogSection.classList.add("active");
        } else {
          researchSection.classList.add("active");
        }
      } else {
        navbar.classList.remove("sticky");
        blogSection.classList.add("active");
      }
      // if (window.pageYOffset >= sticky) {
      //   navbar.classList.add("sticky")
      // } else {
      //   navbar.classList.remove("sticky");
      // }
    }
  }

  ecosystmTvFilter() {
    let filter: any = {};
    filter.limit = 10;
    filter.skip = 2;
    return filter;
  }
  getEcosystmTVList() {
    this.rolesSharedService
      .getEcosystmTVHomepage(this.ecosystmTvFilter())
      .subscribe(
        (response: any) => {
          window.scroll(0, 0);
          this.ecosystmTvList = response as object[];
          response.forEach((value) => {
            this.titles = value["content"];
            if (value["title"]["rendered"].includes("&#038;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#038;", "");
            }
            if (value["title"]["rendered"].includes("&#8211;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8211;", "");
            }
            if (value["title"]["rendered"].includes("&#8221;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8221;", "");
            }
            if (value["title"]["rendered"].includes("&#8217;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8217;", "");
            }
            if (value["title"]["rendered"].includes("&#8216;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8216;", "");
            }
            if (value["title"]["rendered"].includes("&#8210;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8210;", "");
            }
            if (value["title"]["rendered"].includes("&amp;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&amp;", "");
            }
            if (value["title"]["rendered"].includes("&#8220;")) {
              value["title"]["rendered"] = value["title"][
                "rendered"
              ].replaceAll("&#8220;", "");
            }

            var video_id = value["content"]["rendered"].split("v=")[1];
            if (value["content"]["rendered"].includes("https://youtu.be/")) {
              video_id =
                value["content"]["rendered"].split("https://youtu.be/")[1];
            }
            var urlString = "https://www.youtube.com/embed/";
            if (video_id != undefined) {
              var ampersandPosition =
                video_id.indexOf('">') ||
                video_id.indexOf('"') ||
                video_id.indexOf("&") ||
                video_id.indexOf("?t") ||
                video_id.indexOf(";");
              if (ampersandPosition != -1) {
                video_id = video_id.substring(0, ampersandPosition);
                let modifiedVideoId = video_id.replace("&amp;", "&");
                var newVideoId = modifiedVideoId.replace(
                  "&feature=youtu.be",
                  ""
                );
                if (newVideoId.includes("&")) {
                  newVideoId = modifiedVideoId.replace("&", "");
                }
                value.youtubeVideoId =
                  this.domSanitizer.bypassSecurityTrustResourceUrl(
                    urlString.concat(newVideoId.toString())
                  );
              }
            }
          });
        },
        (error) => {}
      );
  }
  viewAllEcosystmTv() {
    window.open(this.ecosystmTvUrl, "_self");
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/external/public-page/public-page.component.ts